import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=4e8016a0&scoped=true"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8016a0",
  null
  
)

export default component.exports